module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Bold-53a6621bbf5f30c4b311bdef006c9a91.woff2";